import { LegacyRef, MutableRefObject, RefCallback } from 'react';

import { CSS } from './stitches.config';
import { defaultFontSize, Distance } from './types';

export const getPixels = (value: Distance): number => {
  if (value === '0') {
    return 0;
  } else if (value.endsWith('px')) {
    return parseFloat(value);
  } else if (value.endsWith('em')) {
    return parseFloat(value) * defaultFontSize;
  } else {
    throw new Error(`Can't calculate pixels from ${value}`);
  }
};

function isObject(val: unknown): val is Record<string, unknown> {
  return val !== null && typeof val === 'object' && !Array.isArray(val);
}

function deepMerge(target: Record<string, unknown>, source: Record<string, unknown>): Record<string, unknown> {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (isObject(source[key]) && isObject(result[key])) {
      result[key] = deepMerge(result[key] as Record<string, unknown>, source[key] as Record<string, unknown>);
    } else {
      result[key] = source[key];
    }
  }
  return result;
}

export const mergeCss = (...css: (CSS | undefined)[]): CSS =>
  css.reduce<CSS>((acc, val) => (val ? deepMerge(acc as Record<string, unknown>, val as Record<string, unknown>) as CSS : acc), {} as CSS);

// export const isToken = (value: unknown): value is Token => {
//   return typeof value === 'string' && value.startsWith('$');
// };

export function mergeRefs<T = unknown>(refs: (MutableRefObject<T> | LegacyRef<T>)[]): RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as MutableRefObject<T | null>).current = value;
      }
    });
  };
}
